import React, { useRef } from "react";
import {
  Chart,
  Series,
  Legend,
  Tooltip,
  ArgumentAxis,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";
import useRatingSorter from "hooks/useRatingSorter";

const EclGapByRating = ({ data, palette }) => {
  const chartRef = useRef(null);
  const sortedData = useRatingSorter(data);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const customizeTooltip = (info) => {
    return {
      html: `
        <div style="padding: 5px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${
            info.argumentText
          }</div>
          <div>ECL Gap: ${formatCurrency(info.point.data.eclGap)}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard title="ECL Gap by Rating" chartRef={chartRef} palette={palette}>
      <div className="p-4">
        <Chart
          dataSource={sortedData}
          id="ratingsChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            name="ECL Gap"
            valueField="eclGap"
            argumentField="rating"
            type="bar"
          />
          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            shared={false}
          />
          <Legend visible={false} />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default EclGapByRating;
